module.exports = {"hello":"Hello","welcome":"Welcome to our website!","item_count":"You have {count} item(s)"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 51